import { render, staticRenderFns } from "./ContinueWithGoogleButton.vue?vue&type=template&id=23f5b105&"
import script from "./ContinueWithGoogleButton.vue?vue&type=script&lang=js&"
export * from "./ContinueWithGoogleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports